// Sayfalayıcı — `.pager` / `.pg` desenini tek yerde toplar.
//
// NEDEN VAR: beş liste ekranı (stok kartları · cariler · mal kabul ·
// laboratuvar · üniteler) aynı bloğu kopyalamıştı ve hepsi
// `Array.from({length: sayfaSayisi})` ile HER sayfa için bir düğme basıyordu.
// Kayıt sayısı büyüdüğünde şerit ekranın dışına taşıyor: 149 sayfalık bir
// listede `.pager` kabından 3.143 px taşıp `.grid-foot` tarafından kırpılıyor,
// düğmeler 4.360 px'e kadar gidiyordu. Referans HTML'de liste iki sayfalık
// olduğu için kusur orada görünmüyor.
//
// PENCERELEME: ilk · … · geçerli±2 · … · son. Toplam sayfa PENCERE_SINIRI'nı
// aşmıyorsa hepsi basılır — referanstaki iki sayfalık görünüm birebir korunur.
//
// SINIF ADLARI: §3.2 gereği `.pager` / `.pg` / `.pg.on` aynen kullanılıyor,
// yeni CSS yazılmadı. Üç nokta da bir `.pg` — ama `disabled`, çünkü tıklanacak
// bir sayfası yok ve klavye sırasında durup kullanıcıyı oyalamamalı.

/** Bu sayının altında pencereleme yok: tüm sayfalar basılır. */
const PENCERE_SINIRI = 9

/** Geçerli sayfanın iki yanında kaç sayfa gösterilecek. */
const KOMSU = 2

/** Üç nokta yer tutucusu — sayfa numarası değil. */
const BOSLUK = 'bosluk'

type Oge = number | typeof BOSLUK

/**
 * Basılacak öğeleri üretir. Ayrı ve saf tutuldu ki sınırları test edilebilsin
 * (bkz. Sayfalayici.test.ts) — asıl kusur "hepsini bas" davranışıydı ve
 * dönüşün uzunluğu sabit kalmalı.
 */
export function sayfaOgeleri(gecerli: number, toplam: number): Oge[] {
  if (toplam <= PENCERE_SINIRI)
    return Array.from({ length: toplam }, (_, i) => i + 1)

  const ogeler: Oge[] = [1]

  // Pencere uçlara yaklaşınca kayar: aksi hâlde şerit uçlarda kısalıp
  // uzayarak düğmelerin yerini oynatırdı.
  let bas = Math.max(2, gecerli - KOMSU)
  let son = Math.min(toplam - 1, gecerli + KOMSU)
  const genislik = KOMSU * 2 + 1
  if (son - bas + 1 < genislik) {
    if (bas === 2) son = Math.min(toplam - 1, bas + genislik - 1)
    else bas = Math.max(2, son - genislik + 1)
  }

  // Tek sayfalık boşluğa üç nokta koymak yer kazandırmıyor, sayfayı gizliyor.
  if (bas > 2) ogeler.push(BOSLUK)
  else if (bas === 3) ogeler.push(2)

  for (let n = bas; n <= son; n++) ogeler.push(n)

  if (son < toplam - 1) ogeler.push(BOSLUK)
  ogeler.push(toplam)

  return ogeler
}

export default function Sayfalayici({
  gecerli,
  toplam,
  git,
}: {
  gecerli: number
  toplam: number
  git: (sayfa: number) => void
}) {
  return (
    <div className="pager">
      <button
        className="pg"
        type="button"
        aria-label="Önceki sayfa"
        disabled={gecerli === 1}
        onClick={() => git(Math.max(1, gecerli - 1))}
      >
        ‹
      </button>

      {sayfaOgeleri(gecerli, toplam).map((oge, i) =>
        oge === BOSLUK ? (
          // key olarak indeks: iki boşluk da aynı metni taşıyor, ayırt edici
          // başka bir değer yok. Liste yeniden sıralanmıyor, güvenli.
          <button key={`b${i}`} className="pg" type="button" disabled aria-hidden="true">
            …
          </button>
        ) : (
          <button
            key={oge}
            className={oge === gecerli ? 'pg on' : 'pg'}
            type="button"
            aria-label={`Sayfa ${oge}`}
            aria-current={oge === gecerli ? 'page' : undefined}
            onClick={() => git(oge)}
          >
            {oge}
          </button>
        ),
      )}

      <button
        className="pg"
        type="button"
        aria-label="Sonraki sayfa"
        disabled={gecerli === toplam}
        onClick={() => git(Math.min(toplam, gecerli + 1))}
      >
        ›
      </button>
    </div>
  )
}
